import PropTypes from "prop-types"
import React, { useEffect } from "react"
import styled from "styled-components"

import { USER_AUTH_HEADER } from "../../../../api"
import { useStateValue } from "../../context/AppStateStore"
import useRestTable from "../../hooks/usePaginatedRestResource"
import Heading from "../Typography/Heading"
import Paragraph from "../Typography/Paragraph"
import ScreenTitle from "../Typography/ScreenTitle"
import BookingsTable from "./BookingsTable"

// ----------------------------------------------------------------------------

function _UserBookings(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [documents] = useRestTable("/documents", USER_AUTH_HEADER)

    const [{ user }] = useStateValue()

    const [bookings, fetchBookings] = useRestTable(
        `/bookings/user-bookings/${user?.id}`,
        USER_AUTH_HEADER,
        {
            enabled: [user?.id],
        }
    )

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        if (user?.id) {
            fetchBookings()
        }
        // eslint-disable-next-line
    }, [user?.id])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderDocuments() {
        return (
            <ul className="documents">
                {documents?.map((doc) => (
                    <li key={doc.id}>
                        <a href={doc.url}>{doc.title}</a>
                    </li>
                ))}
            </ul>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    if (!user?.id || !bookings?.length) {
        return <></>
    }

    return (
        <div className={props.className}>
            <ScreenTitle text="Le tue prenotazioni" />
            <main>
                <div className="info">
                    <Heading boldness="bold">Informazioni utili</Heading>
                    <Paragraph>
                        Da questa sezione puoi visualizzare e cancellare le tue
                        prenotazioni. Ricordati di presentarti all&apos;evento{" "}
                        <b>con 10 minuti di anticipo</b> e di compilare
                        preventivamente i seguenti documenti:
                    </Paragraph>
                    {renderDocuments()}
                </div>
                <Heading className="table-heading" boldness="bold">
                    I tuoi biglietti:
                </Heading>
                <BookingsTable
                    bookings={bookings}
                    fetchBookings={fetchBookings}
                />
            </main>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_UserBookings.propTypes = {
    className: PropTypes.string.isRequired,
}

_UserBookings.defaultProps = {}

// ----------------------------------------------------------------------------

const UserBookings = styled(_UserBookings)`
    & {
        main {
            padding: 50px 200px;
            display: flex;
            flex-direction: column;
            .table-heading {
                margin-top: 50px;
            }
            .documents {
                a {
                    font-size: 18px;
                    color: ${({ theme }) => theme.colors.textMuted};
                    text-decoration: underline;
                }
            }
        }
        @media (max-width: 1200px) {
            main {
                padding: 50px 50px;
            }
        }
        @media (max-width: 780px) {
            main {
                max-width: 100vw;
                padding: 50px 20px;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default UserBookings
